<template>
  <div>
    <b-container style="position: relative;" class="downtown pt-5">
      <b-row style="margin-bottom:-7px;">
        <b-col cols="12" style="position: relative;" class="intro-text mt-md-4">

            <div id="carouselExampleInterval" class="carousel slide" data-bs-ride="carousel">
            <div class="carousel-inner">
              <div class="carousel-item active" data-bs-interval="4000">
                <img src="/img/newSlider/lakeside-1.jpg" fluid class="d-block w-100" alt="lakeside 1">
              </div>
              <div class="carousel-item" data-bs-interval="4000">
                <img src="/img/newSlider/lakeside-2.jpg" fluid class="d-block w-100" alt="lakeside-2">
              </div>
              <div class="carousel-item" data-bs-interval="4000">
                <img src="/img/newSlider/lakeside-3.jpg" fluid class="d-block w-100" alt="lakeside-3">
              </div>
              <div class="carousel-item" data-bs-interval="4000">
                <img src="/img/newSlider/lakeside-4.jpg" fluid class="d-block w-100" alt="lakeside-4">
              </div>
              <div class="carousel-item" data-bs-interval="4000">
                <img src="/img/newSlider/lakeside-5.jpg" fluid class="d-block w-100" alt="lakeside-5">
              </div>
              <div class="carousel-item" data-bs-interval="4000">
                <img src="/img/newSlider/lakeside-6.jpg" fluid class="d-block w-100" alt="lakeside-6">
              </div>
            </div>
            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleInterval" data-bs-slide="prev">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleInterval" data-bs-slide="next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Next</span>
            </button>
        </div>

        </b-col>
      </b-row>
      <div class="textDowntown">
        <b-row>
          <b-col cols="12" class="d-md-none">
            <h1>
              FOR THOSE <br>
              WHO VALUE...<br>
              LIFE BY THE LAKE

              FOR THOSE
              WHO VALUE...
              CONVENIENT
              LOCAL SHOPPING
              &amp; DINING
            </h1>
          </b-col>
          <b-col
            cols="12"
            offset="0"
            md="5"
            offset-md="1"
            lg="4"
            offset-lg="2"
            class="py-3"
          >
            <p>
              Lakeside living brings added value to your life in multitude
              of ways. Stay active swimming, sailing, kayaking, fishing or
              simply unwind at the beach in the warmer months. In the
              colder seasons, enjoy your time with friends and family
              exploring trails, and skating or ice fishing on the lake. Life
              by that water has much to offer year round!
            </p>
            <p>
              Escape on a short bicycle ride or drive to Wilkin's Beach, or
              the popular Innisfil Beach Park to the South. Boat lovers will
              appreciate access to nearby marinas and launches, and
              everyone is sure to love the short distance to downtown
              Barrie's beautiful boardwalk. Your most valuable life by the
              lake is waiting.
            </p>
            <b-img class="waves" src="/img/waves.png" width="50" fluid />
          </b-col>
          <b-col cols="5" class="d-none d-md-block">
            <h1>
              FOR THOSE <br>
              WHO VALUE...<br>
              LIFE BY THE LAKE
            </h1>
          </b-col>
        </b-row>
      </div>
      <!-- <b-col md="2" offset-md="1" offset-lg="2" class="d-none d-sm-none d-md-block arrows">
        <b-row>
          <b-col @click="prev">
            &larr;
          </b-col>
          <b-col @click="next">
            &rarr;
          </b-col>
        </b-row>
      </b-col> -->
    </b-container>
  </div>
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
      slide: 0,
      sliding: null
      // downtownSlick: {
      //   speed: 1500,
      //   autoplay: true,
      //   autoplaySpeed: 2500,
      //   slidesToShow: 1,
      //   arrows: true,
      //   infinite: true,
      //   dots: false,
      //   responsive: [{
      //     breakpoint: 768,
      //     settings: {
      //       dots: true
      //     }
      //   }]
      // }
    }
  },
  mounted() {
  },
  methods: {
    next() {
      this.$refs.myCarousel.next()
    },
    prev() {
      this.$refs.myCarousel.prev()
    },
  }
}
</script>
<style lang="scss">
.downtown{
  .image-holder{
    img{
      width: 100%;
    }
  }
  .slick-arrow{
    background-color: red;
  }

  .textDowntown{
    @media screen and (max-width: 767px){
          text-align: center;
          margin-top: -40px;
        }
      background-color: #F1F1F2;
      h1{
        padding: 25px 0px 25px 50px;
        font-size: 40px;
        @media screen and (max-width: 768px){
          font-size: 25px;
          padding: 60px 0px 0px 0px;
        }
        @media screen and (min-width: 768px) and (max-width: 1000px){
          padding: 25px 0px 0px 0px;
        }
        font-weight: normal;
        color: #F05B2D;
      }
      p{
        // padding: 25px 0px;
        // @media screen and (max-width: 768px){
        //   padding: 15px;
        // }
        font-size: 14px
      }
  }
}

</style>
